import React from 'react';
import { Field } from 'components/form';
import withWidget from './with-widget';

function SwellFile({ value, onChange, field }) {
  return (
    <Field
      type="file"
      name={field.prop}
      label={field.label}
      onChange={onChange}
      value={value}
    />
  );
}

export default withWidget(SwellFile);
